import { useEffect, useLayoutEffect } from "react";
import { canUseDOM } from "./auth-service-tools646.js";
var useIsomorphicEffect = !canUseDOM ? useEffect : useLayoutEffect;
export { useIsomorphicEffect };